import createMutationsSharer from 'vuex-shared-mutations'
import { setInLocalStorage } from 'helpers/localStorageHelper'

const localStoragePlugin = store => {
    store.subscribe((mutation, {
        previousPathBeforeLogin,
        userId,
        User,
        ChatBot,
        notification,
        notificationVisible,
        liveWatchedTimes,
        isSidebarCollapsed,
        isSearchMobileCollapsed,
        isListViewVertical,
        sharedWatchlistModalShown
    }) => {
        if (mutation.type === 'SET_PREVIOUS_PATH_BEFORE_LOGIN') {
            if (previousPathBeforeLogin === null) {
                window.sessionStorage.removeItem('previousPathBeforeLogin')
            } else {
                window.sessionStorage.setItem('previousPathBeforeLogin', JSON.stringify(previousPathBeforeLogin))
            }
        }
        if (['LOGIN', 'LOGOUT'].includes(mutation.type)) {
            window.localStorage.setItem('userId', JSON.stringify(userId))
        }
        if (mutation.type === 'User/SET_CURRENT_USER') {
            window.localStorage.setItem('currentUser', JSON.stringify(User.currentUser))
        }
        if (mutation.type === 'User/LOGOUT') {
            window.localStorage.removeItem('currentUser')
        }
        if (mutation.type === 'SET_SHARE_WATCHLIST_MODAL_SHOWN') {
            window.localStorage.setItem('sharedWatchlistModalShown', JSON.stringify(sharedWatchlistModalShown))
        }
        if (mutation.type === 'User/SET_SESSION_EXPIRATION') {
            if (User.sessionExpiration === null) {
                window.sessionStorage.removeItem(localStorageKeys.sessionExpiration)
            } else {
                window.localStorage.setItem(localStorageKeys.sessionExpiration, JSON.stringify(User.sessionExpiration))
            }
        }
        if (mutation.type === 'ChatBot/SET_CHAT_TOKEN_EXPIRATION') {
            setInLocalStorage(localStorageKeys.chatTokenExpiration, ChatBot.chatTokenExpiration)
        }
        if (mutation.type === 'ChatBot/SET_CHAT_TOKEN_REFRESH_TIME') {
            setInLocalStorage(localStorageKeys.chatTokenRefreshTime, ChatBot.chatTokenRefreshTime)
        }

        window.localStorage.setItem('notification', JSON.stringify(notification))
        window.localStorage.setItem('notificationVisible', JSON.stringify(notificationVisible))
        window.localStorage.setItem('liveWatchedTimes', JSON.stringify(liveWatchedTimes))
        window.localStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed))
        window.localStorage.setItem('isSearchMobileCollapsed', JSON.stringify(isSearchMobileCollapsed))
        window.localStorage.setItem('isListViewVertical', JSON.stringify(isListViewVertical))
    })
}

const mutationSharer = createMutationsSharer({
    predicate: [
        'CompletedCourses/SET_RELOAD_LEARNING_PATHS'
    ]
})

export const localStorageKeys = {
    sessionExpiration: 'sessionExpiration',
    chatTokenExpiration: 'chatTokenExpiration',
    chatTokenRefreshTime: 'chatTokenRefreshTime'
}

export default [ localStoragePlugin, mutationSharer ]
